import React from 'react';
import styled from 'styled-components/macro';
import { Colors } from '@cognite/cogs.js';
import { TableProps } from 'antd';

export const TableContainer = ({
  children,
}: {
  children: React.ReactElement<TableProps<any>>;
}) => <StyledTable>{children}</StyledTable>;

const StyledTable = styled.div`
  .ant-table {
    background: transparent;
  }
  table {
    border-spacing: 0 4px;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 10px 16px;
  }
  .ant-table-expanded-row.ant-table-expanded-row-level-1 > .ant-table-cell {
    // for nested tables
    padding: 0 0 16px 0;
    border-bottom: none;
  }

  .ant-table-thead {
    > tr > th {
      border-bottom: none;
      background: transparent;
    }
  }
  .ant-table-row {
    background: var(--cogs-white);
    box-shadow: var(--cogs-z-4);
    cursor: pointer;
  }
  .ant-table-column-sorters {
    padding: 0 16px 0 0;
  }
  .anticon.ant-table-column-sorter-up,
  .anticon.ant-table-column-sorter-down {
    &.active {
      color: var(--cogs-text-primary);
    }

    .row-clickable > .ant-table-cell:hover {
      cursor: pointer;
    }
  }
`;
